import { render, staticRenderFns } from "./maintainWhiteList.vue?vue&type=template&id=056d2bfe&"
import script from "./maintainWhiteList.vue?vue&type=script&lang=js&"
export * from "./maintainWhiteList.vue?vue&type=script&lang=js&"
import style0 from "./maintainWhiteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports